import type { PlatformBillingInterval } from '@ruta/shared';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { formatWholeDollars } from '@/lib/utils';

/** The same billing schedule selector at signup and in Settings → Plan. */
export function PlatformBillingChoice({ value, monthlyPrice, annualPrice, onChange, disabled = false }: {
  value: PlatformBillingInterval;
  monthlyPrice: number;
  annualPrice?: number | null;
  onChange: (value: PlatformBillingInterval) => void;
  disabled?: boolean;
}) {
  return (
    <Select value={value} onValueChange={(next) => onChange(next as PlatformBillingInterval)} disabled={disabled}>
      <SelectTrigger aria-label="Billing schedule"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="monthly">{formatWholeDollars(monthlyPrice)} a month</SelectItem>
        {annualPrice != null && <SelectItem value="annual">{formatWholeDollars(annualPrice)} a year</SelectItem>}
      </SelectContent>
    </Select>
  );
}
